import { configureStore } from "@reduxjs/toolkit";
import calendarSlice from "./slices/calendarSlice";
import eventSlice from "./slices/eventSlice";
import coachSlice from "./slices/coachSlice";
import userSlice from "./slices/userSlice";
import adminSlice from "./slices/adminSlice";
import athleteSlice from "./slices/athleteSlice";
import accountSlice from "./slices/accountSlice";
import combineSlice from "./slices/combineSlice";
import profileVideoSlice from "./slices/profileVideoSlice";
import additionalInfoSlice from "./slices/additionalInfoSlice";
import measurementSlice from "./slices/measurementSlice";

export default configureStore({
  reducer: {
    calendar: calendarSlice,
    events: eventSlice,
    coaches: coachSlice,
    user: userSlice,
    admin: adminSlice,
    athletes: athleteSlice,
    account: accountSlice,
    combine: combineSlice,
    profileVideo: profileVideoSlice,
    additionalInfo: additionalInfoSlice,
    measurement: measurementSlice,
  },
});
